import React, { memo, useState } from "react";
import {
  Divider,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import TLDRDownloadOptionsWrapper from "../../_components/details/downloadArtboards/TLDRDownloadOptionsWrapper";
import { FaChevronLeft } from "react-icons/fa";

const ExportStoryModal = ({ story, onClose, onExportEnd, onDownloading = () => { }, showHeader = true }) => {
  const [inProgress, setInProgress] = useState(false);

  function handleDownloading(state) {
    setInProgress(state);
    if (onDownloading) onDownloading(state);
  };

  return (
    <>
      {showHeader ? (
        <>
          <HStack alignItems="center" my="1">
            <Icon
              as={FaChevronLeft}
              ml="0"
              onClick={onClose}
              _hover={{
                color: "brand.primary",
                cursor: "pointer"
              }}
            />
            <Text
              fontSize="sm"
              fontWeight="bold"
            >
              Share
            </Text>
          </HStack>

          <Divider my="2" />
        </>
      ) : null}

      <TLDRDownloadOptionsWrapper
        show
        inline
        story={story}
        onDownloading={handleDownloading}
        onExportEnd={onExportEnd}
        supportedFileTypes={["png", "jpeg", "mp4"]}
        maxVideoHeight={720}
        disableTransparentChange
        disableSizeChange
      />
    </>
  );
};

export default memo(ExportStoryModal);
